import axios from 'axios';
import { editAssignmentQuery } from './queries';

const editAssignment = (model, key) =>
    new Promise((resolve, reject) => {
        const query = editAssignmentQuery({ model, key });
        const request = axios.put(query.url, { ...query.body });
        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to edit Assignment'));
            });
    });

export default editAssignment;
